import React from 'react';
import { cn } from '@/lib/utils';

export function QuestionPalette({
  total,
  currentIndex,
  answers,
  marked,
  onJump,
}) {
  const items = Array.from({ length: total }, (_, i) => i);
  return (
    <div className="space-y-4" data-testid="question-palette">
      <div>
        <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">Question palette</div>
        <div className="grid grid-cols-5 gap-2 sm:grid-cols-7">
          {items.map((i) => {
            const isCurrent = i === currentIndex;
            const answered = answers[i] !== undefined && answers[i] !== null;
            const isMarked = marked.has(i);
            let state = 'not_visited';
            if (answered && isMarked) state = 'answered_marked';
            else if (answered) state = 'answered';
            else if (isMarked) state = 'marked';
            return (
              <button
                key={i}
                type="button"
                onClick={() => onJump(i)}
                className={cn(
                  'palette-tile grid h-10 w-10 place-items-center rounded-md border text-sm font-medium transition-colors',
                  state === 'not_visited' && 'bg-[hsl(var(--palette-not-visited)/0.35)] text-foreground hover:bg-[hsl(var(--palette-not-visited)/0.55)]',
                  state === 'answered' && 'bg-[hsl(var(--palette-answered)/0.18)] border-[hsl(var(--palette-answered)/0.5)] text-[hsl(var(--palette-answered))]',
                  state === 'marked' && 'bg-[hsl(var(--palette-marked)/0.18)] border-[hsl(var(--palette-marked)/0.5)] text-[hsl(var(--palette-marked))]',
                  state === 'answered_marked' && 'bg-[hsl(var(--palette-marked)/0.18)] border-[hsl(var(--palette-marked)/0.6)] text-[hsl(var(--palette-marked))]',
                  isCurrent && 'ring-2 ring-[hsl(var(--palette-current))] border-[hsl(var(--palette-current))]'
                )}
                data-testid={`question-palette-tile-${i + 1}`}
                aria-label={`Question ${i + 1}`}
              >
                {i + 1}
              </button>
            );
          })}
        </div>
      </div>
      <div className="space-y-1.5 text-xs">
        <div className="flex items-center gap-2">
          <span className="inline-block h-3 w-3 rounded-sm bg-[hsl(var(--palette-answered)/0.4)] border border-[hsl(var(--palette-answered)/0.6)]" />
          <span className="text-muted-foreground">Answered</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-block h-3 w-3 rounded-sm bg-[hsl(var(--palette-marked)/0.4)] border border-[hsl(var(--palette-marked)/0.6)]" />
          <span className="text-muted-foreground">Marked for review</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-block h-3 w-3 rounded-sm bg-[hsl(var(--palette-not-visited)/0.5)] border" />
          <span className="text-muted-foreground">Not visited / unanswered</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-block h-3 w-3 rounded-sm border-2 border-[hsl(var(--palette-current))]" />
          <span className="text-muted-foreground">Current</span>
        </div>
      </div>
    </div>
  );
}
